import ToollBar from "./Toollbar";
import ListBoard from './ListBoard';
import { IOccurrence } from "../types";
import { SelectOption } from "@rio-cloud/rio-uikit";

interface Props {
    data: IOccurrence[];
    handleSearch: (text: string) => void;
    handleDn: (text: string) => void;
    handleSupportType: (subject: string) => void;
    handleSort: (optionId: string) => void;
    isLoading: boolean;
    optionsAssigned: SelectOption[];
    search?: string;
    dn?: string;
    sortBy?: string;
    sortDirection?: string;
    supportType: string;
    handleAssignedChange: (values: string[]) => void;
    assignedSelection: string[];
    onOpenSettings: () => void;
}

const SupportBoard = ({
    data, 
    handleSearch, 
    handleSupportType, 
    handleDn, 
    handleSort,
    isLoading, 
    optionsAssigned,
    search,
    dn,
    sortBy,
    sortDirection,
    supportType,
    handleAssignedChange,
    assignedSelection,
    onOpenSettings,
}: Props) => {
    return (
        <div>
            <ToollBar 
                handleSearch={handleSearch} 
                handleSupportType={handleSupportType} 
                handleDn={handleDn} 
                handleSort={handleSort}
                optionsAssigned={optionsAssigned}
                search={search}
                dn={dn}
                sortBy={sortBy}
                sortDirection={sortDirection}
                supportType={supportType}
                handleAssignedChange={handleAssignedChange}
                assignedSelection={assignedSelection}
                onOpenSettings={onOpenSettings}
            />
            <ListBoard data={data} isLoading={isLoading} />
        </div>
    )
}

export default SupportBoard;